export default __webpack_public_path__ + "static/media/color.35856fd6.svg";